import React, { useEffect, useState } from "react";
import Header from "./../components/Header";
import Rating from "../components/homeComponents/Rating";
import { Link } from "react-router-dom";
import Message from "./../components/LoadingError/Error";
import { useDispatch, useSelector } from "react-redux";
import {
  createProductReview,
  listProductDetails,
} from "../Redux/Actions/ProductActions";
import Loading from "../components/LoadingError/Loading";
import { PRODUCT_CREATE_REVIEW_RESET } from "../Redux/Constants/ProductConstants";
import moment from "moment";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import QuantityInput from "../components/QuantityInput";
import {
  DEFAULT_CURRENCY,
  IMAGE_CACHE_URL,
  SHOP_NAME,
} from "../Redux/Constants/GlobalConstant";
import MobileNav from "../components/MobileNav";
import BestDealSection from "../components/homeComponents/BestDealSection";
// import { toTitleCase } from "../helper/util";
import "./SingleProduct.css";

const SingleProduct = ({ history, match }) => {
  // const [qty] = useState(0);
  // const [isAddedToCart, setIsAddedToCart] = useState(false);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  // const [productData, setProductData] = useState([]);
  const [tempImages, setTempImages] = useState([]);
  const [type, setType] = useState("");
  const [description, setDescription] = useState("");
  const [activeTab, setActiveTab] = useState("description");
  // const [activeThumb, setActiveThumb] = useState(0);

  const productId = match.params.id;
  const dispatch = useDispatch();

  const productDetails = useSelector((state) => state.productDetails);
  const { loading, error, product } = productDetails;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const productReviewCreate = useSelector((state) => state.productReviewCreate);
  const {
    loading: loadingCreateReview,
    error: errorCreateReview,
    success: successCreateReview,
  } = productReviewCreate;

  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;
  const productCartItem = cartItems.find((x) => x.product === productId);
  const cartQty = productCartItem ? productCartItem.qty : 0;

  useEffect(() => {
    if (successCreateReview) {
      alert("Review Submitted");
      setRating(0);
      setComment("");
      dispatch({ type: PRODUCT_CREATE_REVIEW_RESET });
    }
    if (productId) dispatch(listProductDetails(productId));
  }, [dispatch, productId, successCreateReview]);

  useEffect(() => {
    // if (!product?._id) setProductData(product);
    if (product?._id) {
      setTempImages([]);
      setTempImages((prev) => [...prev, product.image]);

      if (product?.images) {
        product?.images.forEach((element, i) => {
          setTempImages((prev) => [...prev, element]);
        });
      }
      product?.attribute_collection.forEach((ele) => {
        if (ele?.title === "Description") setDescription(ele.value);
        // if (ele?.title === "Unit") setUnit(ele.value);
        if (ele?.value === "Type") setType(ele.title);
      });
    }
  }, [productId, product]);

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(
      createProductReview(productId, {
        rating,
        comment,
      }),
    );
  };

  // Calculate discount percentage
  // const discountPercent =
  //   product?.mrp_price && product?.price && product.mrp_price > product.price
  //     ? Math.round(((product.mrp_price - product.price) / product.mrp_price) * 100)
  //     : 0;

  return (
    <>
      <Header />
      <MobileNav />

      <div className="pdp-container">
        {loading ? (
          /* Loading Skeleton */
          <div className="pdp-skeleton-hero">
            <div className="pdp-skeleton-img"></div>
            <div className="pdp-skeleton-info">
              <div className="pdp-skeleton-line short"></div>
              <div className="pdp-skeleton-line title"></div>
              <div className="pdp-skeleton-line medium"></div>
              <div className="pdp-skeleton-line long"></div>
              <div className="pdp-skeleton-line medium"></div>
            </div>
          </div>
        ) : error ? (
          <Message variant="alert-danger">{error}</Message>
        ) : (
          <div className="pdp-page">

            {/* =============================================
                HERO — Image Gallery + Product Info
               ============================================= */}
            <div className="pdp-hero">

              {/* //Image Section */}
              <div className="pdp-image-col">


                {/* Auto-playing Carousel — original style */}
                <Carousel
                  autoPlay={true}
                  infiniteLoop={true}
                  showIndicators={true}
                  thumbWidth="15%"
                  interval={3000}
                >
                  {tempImages?.map((image, i) => (
                    <div key={i}>
                      <img src={IMAGE_CACHE_URL + image} alt={product.name} />
                      {/* <p className="legend">{i}</p> */}
                    </div>
                  ))}
                </Carousel>
              </div>



              {/* // Product Overview */}
              <div className="pdp-info-col">

                {/* Title */}
                <h1 className="pdp-title">{product.name}</h1>

                {/* Rating */}
                <div className="pdp-rating-row">
                  <div className="pdp-stars">
                    <Rating value={product.rating} />
                  </div>
                  <span className="pdp-review-count">
                    ({product.numReviews} reviews)
                  </span>
                </div>

                {/* Price */}
                <div className="pdp-price-row">
                  <span className="pdp-price-current">
                    {DEFAULT_CURRENCY}{product.price}
                  </span>
                  {product.mrp_price && product.mrp_price > product.price && (
                    <span className="pdp-price-old">
                      {DEFAULT_CURRENCY}{product.mrp_price}
                    </span>
                  )}
                </div>


                {/* Short Description */}
                <p className="pdp-desc-short">
                  {!description &&
                    "Get this product -" +
                      product.name +
                      "- delivered to your doorstep fast, fresh, and straight from a store near you. Shop now with " +
                      SHOP_NAME +
                      " and enjoy authentic taste at an affordable price."}
                  {/* {description && description} */}
                </p>

                {/* Type & Unit */}
                {type && (
                  <div style={{ fontSize: 14, color: "var(--c-on-surface-variant)" }}>
                    <strong>Type:</strong> {type}
                  </div>
                )}
                {product.unit && (
                  <div style={{ fontSize: 14, color: "var(--c-on-surface-variant)" }}>
                    <strong>Unit:</strong> {product.unit}
                  </div>
                )}

                {/* Purchase Row — Qty */}
                <div className="pdp-purchase-row">
                  <QuantityInput
                    productId={product._id}
                    renderAddButton={true}
                    qty={cartQty}
                  />
                </div>

                {/* Promise Mini-Cards */}
                <div className="pdp-mini-promises">
                  <div className="pdp-mini-card">
                    <span className="pdp-mini-emoji">📦</span>
                    <span>Quick Deliver</span>
                  </div>
                  <div className="pdp-mini-card">
                    <span className="pdp-mini-emoji">🌶️</span>
                    <span>Authentic Flavor &amp; Taste</span>
                  </div>
                  <div className="pdp-mini-card">
                    <span className="pdp-mini-emoji">💷</span>
                    <span>Best Price Guaranteed</span>
                  </div>
                </div>
              </div>
            </div>

            {/* =============================================
                FEATURES — Why Aaroh Food
               ============================================= */}
            {/* // About Agrocroft */}
            <div className="pdp-why-heading">
              <h2 className="pdp-why-title">Why Aaroh Food?</h2>
            </div>
            <div className="pdp-features">
              <div className="pdp-feature-card">
                <div className="pdp-feature-logo">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 3h15v13H1V3zM16 8h4l3 3v5h-7V8z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
                    <circle cx="5.5" cy="18.5" r="1.5" stroke="currentColor" strokeWidth="1.8"/>
                    <circle cx="18.5" cy="18.5" r="1.5" stroke="currentColor" strokeWidth="1.8"/>
                  </svg>
                </div>
                <div className="pdp-feature-text">
                  <h4>Instant Delivery</h4>
                  <p>Get your essentials delivered to your doorstep swiftly and reliably, saving you time and hassle.</p>
                </div>
              </div>

              <div className="pdp-feature-card">
                <div className="pdp-feature-logo">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 7l10 5 10-5-10-5z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
                    <path d="M2 17l10 5 10-5" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
                    <path d="M2 12l10 5 10-5" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="pdp-feature-text">
                  <h4>Best Price &amp; Offers</h4>
                  <p>Enjoy unbeatable prices and exclusive offers on all your favorite products. Save more today!</p>
                </div>
              </div>

              <div className="pdp-feature-card">
                <div className="pdp-feature-logo">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="pdp-feature-text">
                  <h4>Wide Range &amp; Unbeatable</h4>
                  <p>Discover an extensive selection of products with unbeatable quality and prices. Shop now!</p>
                </div>
              </div>
            </div>

            {/* =============================================
                TABS — Description / Specifications / Reviews
               ============================================= */}
            <div className="pdp-tabs">
              <div className="pdp-tab-header">
                <button
                  className={`pdp-tab-btn ${activeTab === "description" ? "pdp-tab-active" : ""}`}
                  onClick={() => setActiveTab("description")}
                >
                  Description
                </button>

                <button
                  className={`pdp-tab-btn ${activeTab === "reviews" ? "pdp-tab-active" : ""}`}
                  onClick={() => setActiveTab("reviews")}
                >
                  Reviews ({product?.numReviews || 0})
                </button>
              </div>

              <div className="pdp-tab-content">

                {/* DESCRIPTION TAB */}
                {activeTab === "description" && (
                  <div className="pdp-desc-grid">
                    <div className="pdp-desc-text">
                      <h4>Additional Information</h4>
                      <p className="pdp-desc-para">
                        {!description &&
                          "Get this product -" +
                            product.name +
                            "- delivered to your doorstep fast, fresh, and straight from a store near you. Shop now with " +
                            SHOP_NAME +
                            " and enjoy authentic taste at an affordable price."}
                        {/* {description && description} */}
                      </p>
                      <p className="pdp-desc-para">
                        Bring home the best with our carefully curated grocery selection — whether you're stocking up your pantry, preparing a healthy meal, or simply looking for your everyday essentials.
                      </p>
                      {/* Why Shop with Us — glassy cards */}
                      <div className="pdp-why-shop-heading">Why Shop with Us?</div>
                      <div className="pdp-why-shop-grid">
                        <div className="pdp-why-card">
                          <div className="pdp-why-icon-circle" style={{ backgroundColor: "rgba(46, 125, 50, 0.1)" }}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                          </div>
                          <span>100% Quality Assurance</span>
                        </div>
                        <div className="pdp-why-card">
                          <div className="pdp-why-icon-circle" style={{ backgroundColor: "rgba(255, 152, 0, 0.1)" }}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="#e65100" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M1 3h15v13H1V3zM16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="1.5"/><circle cx="18.5" cy="18.5" r="1.5"/></svg>
                          </div>
                          <span>Fast &amp; Safe Delivery</span>
                        </div>
                        <div className="pdp-why-card">
                          <div className="pdp-why-icon-circle" style={{ backgroundColor: "rgba(0, 150, 136, 0.1)" }}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="#004d40" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 3.28 2 8 0 4.5-3.5 8-8 10zm-5 -5v0a1.5 1.5 0 0 1 3 0v0a1.5 1.5 0 0 1 -3 0z"/></svg>
                          </div>
                          <span>Fresh &amp; Sustainably Sourced</span>
                        </div>
                        <div className="pdp-why-card">
                          <div className="pdp-why-icon-circle" style={{ backgroundColor: "rgba(103, 58, 183, 0.1)" }}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="#311b92" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 8V20.9932C21 21.5501 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 20.9932V8H21ZM21 4V6H3V4C3 3.44772 3.44772 3 4 3H9V1H15V3H20C20.5523 3 21 3.44772 21 4Z"/></svg>
                          </div>
                          <span>Easy Returns &amp; Reliable Support</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}



                {/* REVIEWS TAB */}
                {activeTab === "reviews" && (
                  <div>
                    {/* RATING */}
                    {product?.reviews && product?.reviews?.length !== 0 && (
                      <div className="pdp-reviews-list">
                        {product?.reviews?.length === 0 && (
                          <Message variant={"alert-info mt-3"}>No Reviews</Message>
                        )}
                        {product?.reviews?.map((review, index) => (
                          <div key={index + "feed"} className="pdp-review-card">
                            <div className="pdp-review-header">
                              <div className="pdp-review-avatar">
                                {review.name?.charAt(0)?.toUpperCase()}
                              </div>
                              <div>
                                <div className="pdp-review-name">{review.name}</div>
                                <Rating value={review.rating} />
                              </div>
                              <span className="pdp-review-date">
                                {moment(review.createdAt).calendar()}
                              </span>
                            </div>
                            <div className="pdp-review-comment">{review.comment}</div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Write Review Form */}
                    <h6 className="pdp-review-form-title">Write a Customer Review</h6>
                    <div className="my-4">
                      {loadingCreateReview && <Loading />}
                      {errorCreateReview && (
                        <Message variant="alert-danger">{errorCreateReview}</Message>
                      )}
                    </div>
                    {userInfo ? (
                      <form onSubmit={submitHandler}>
                        <div className="pdp-review-form-group">
                          <label>Rating</label>
                          <select value={rating} onChange={(e) => setRating(e.target.value)}>
                            <option value="">Select...</option>
                            <option value="1">1 - Poor</option>
                            <option value="2">2 - Fair</option>
                            <option value="3">3 - Good</option>
                            <option value="4">4 - Very Good</option>
                            <option value="5">5 - Excellent</option>
                          </select>
                        </div>
                        <div className="pdp-review-form-group">
                          <label>Comment</label>
                          <textarea
                            row="3"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                          ></textarea>
                        </div>
                        <div className="my-3">
                          <button
                            disabled={loadingCreateReview}
                            className="pdp-review-submit-btn"
                          >
                            SUBMIT REVIEW
                          </button>
                        </div>
                      </form>
                    ) : (
                      <div className="pdp-login-prompt">
                        Please{" "}
                        <Link to="/login-otp">
                          " <strong>Login</strong> "
                        </Link>{" "}
                        to write a review{" "}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* =============================================
                CUSTOMER FEEDBACK CTA
               ============================================= */}
            <div className="pdp-feedback-section">
              <div className="pdp-feedback-inner">
                <h2 className="pdp-feedback-title">Have you tried this product?</h2>
                <p className="pdp-feedback-sub">
                  Share your experience with our community. Your feedback helps others find the best fresh groceries.
                </p>
                <button
                  className="pdp-feedback-btn"
                  onClick={() => setActiveTab("reviews")}
                >
                  ✏️ Write a Review
                </button>
              </div>
            </div>

            {/* =============================================
                BEST DEALS
               ============================================= */}
            <div className="pdp-best-deals">
              <div className="pdp-deals-header">
              
              </div>
              <BestDealSection></BestDealSection>
            </div>

          </div>
        )}
      </div>

      {/* STICKY ADD TO CART — Mobile Only */}
      {!loading && !error && product?._id && (
        <div className="pdp-sticky-cta">
          <div className="pdp-sticky-cta-price" style={{ flex: 1 }}>
            <div className="price-main">{DEFAULT_CURRENCY}{product.price}</div>
            {product.mrp_price && product.mrp_price > product.price && (
              <div className="price-old">{DEFAULT_CURRENCY}{product.mrp_price}</div>
            )}
          </div>
          <QuantityInput
            productId={product._id}
            renderAddButton={true}
            qty={cartQty}
          />
        </div>
      )}
    </>
  );
};

export default SingleProduct;
